import { Box, Button, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { InsertEmoticon } from "@material-ui/icons";
import { useState, useEffect } from 'react';
import { addConnectionToProvider } from "../api/providerInfo";
import ActivityBranchMatrix from "../components/ActivityBranchMatrix";
import { fetchProviderInfo} from "../api/providerInfo";

const useStyles = makeStyles((theme) => ({
    noDataAvailable: {
        width: '100%',
        height: '300px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        '& .MuiSvgIcon-root': {
            height: '2em',
            width: '2em',
            marginBottom: '1em'
        },
        '& .MuiTypography-root': {
            marginBottom: '1em'
        }
    },
    providerLogo: {
        maxWidth: '100%',
        margin: theme.spacing(0, 2, 1, 2),
        borderRadius: '4px',
    },
    indicator: {
        display: 'flex',
        alignItems: 'center',
        '& .MuiSvgIcon-root': {
            marginRight: theme.spacing(1),
            color: theme.palette.text.secondary,
        },
        '& p': {
            margin: theme.spacing(0.5, 0, 1, 0),
        }
    },
    providerDetails: {},
    topHeading: {
        display: 'flex',
        margin: theme.spacing(0.5, 0, 2, 0),
        alignItems: 'center',
    }
}));


export default function OverviewPage({providerId,  user, handleOpen, onProviderInfoUpdate }) {
    
    const [loading, setLoading] = useState(true);
    const [providerInfo, setProviderInfo] = useState({});

    useEffect(() => {
        if (!!user) {
            setLoading(true);
            console.log("Not admin => fetch providerInfo")
            fetchProviderInfo(providerId, user.token).then(data => {
                console.log("RES", data)
                setProviderInfo(data)
            }).catch(() => {
                // means we got a non 2XX status code => provider info does not exist
                // => disable the navigation buttons
            }).finally(() => {
                setLoading(false);
            })
        }
         else {
            console.log("No user logged in");
        }
    }, [user]);

    const classes = useStyles();
    const hasData = !!providerInfo._id;
    const [isEditable, setIsEditable] = useState(false);

    const toggleEdit = () => {
        setIsEditable((s) => !s);
    }
    const handleSave = (data) => {
        return addConnectionToProvider(providerInfo._id, data, user.token)
            .then(data => onProviderInfoUpdate(data)).then(() => setIsEditable(false))
    }

    const handleCancel = () => {
        setIsEditable(false)
    }


    if (!hasData) {
        return (
            <Paper style={{ padding: '2em' }} variant="outlined">
                <Box className={classes.noDataAvailable}>
                    <InsertEmoticon />
                    <Typography variant="h5"> Welcome to MazingDay </Typography>
                    <Typography variant="h6"> Get started by adding Provider Info</Typography>
                    <Button variant="contained" color="primary" disableElevation onClick={handleOpen}>Add Provider
                    Info</Button>
                </Box>
            </Paper>
        );
    }

    return (
        <Paper style={{ padding: '2em' }} variant="outlined">
            {/* { JSON.stringify(providerInfo.activities)}
            <br/><br/>
            { JSON.stringify(providerInfo.branches)}
            <br/><br/>
            { JSON.stringify(providerInfo.connections)} */}
            <ActivityBranchMatrix
                activities={providerInfo.activities}
                connections={providerInfo.connections}
                branches={providerInfo.branches}
                editable={isEditable}
                onProviderInfoUpdate={onProviderInfoUpdate}
                handleCancel={handleCancel}
                onSave={handleSave}
                toggleEdit={toggleEdit}
                user={user} />
        </Paper >
    );
}
